import { api } from 'app/utils/api/helpers'

export const getIncomeTableForAgency = (
  agencyGUID,
  state = '',
  scheme = 'VARC',
) => {
  const queryString = state
    ? `jurisdiction=${state}&scheme=${scheme}`
    : `scheme=${scheme}`
  return api.get(`/sm/teams/${agencyGUID}/incometables?${queryString}`)
}

export const getIncomeTableForProperty = (agencyGUID, incomeTableGUID) => {
  return api.get(`/sm/teams/${agencyGUID}/incometables/${incomeTableGUID}`)
}
